module.exports = __webpack_public_path__ + "img/dice.b9ce9678.svg";